import { useNavigate } from "react-router-dom";
import { useUserPersonalInfo } from "api/user/useGetCurrentUserPersonalInfo";

const useUbaAuthToken = () => {
  const navigate = useNavigate();
  const { getUserPersonalInfo } = useUserPersonalInfo();

  const handleAuth = async () => {
    try {
      const info = await getUserPersonalInfo();
      const hasCompletedProfile =
        info.firstName && info.lastName && info.acceptedPolicy;

      if (hasCompletedProfile) {
        navigate("/thebai/exams-available");
      } else {
        navigate("/user/info/change");
      }
    } catch (err) {
      console.error("Error fetching user info", err);
      navigate("/user/info/change");
    }
  };

  return { handleAuth };
};

export default useUbaAuthToken;
